// ---------------------------------------------------------------------------
// Latency grader-type descriptor. Authored in-page via the latency flow;
// read-only after creation and has no Evaluate tab (it surfaces an
// agent-reported latency value rather than running a model). Contributes the
// Metric + Latency source Overview cards. (Server→view spec mapping lives in the
// domain-layer mapper next to the Grader model, so this UI descriptor stays free
// of that concern.)
// ---------------------------------------------------------------------------

import { Timer20Regular } from '@fluentui/react-icons';
import { lazy } from 'react';

import type { GraderTypeDescriptor } from '../graderType.types.js';

import { LatencyOverviewSections } from './LatencyOverviewSections.js';

// Lazy so importing the registry (done by the lightweight create menu, grader
// list, and Overview tab) does not eagerly pull the create flow's heavier module
// graph — the create layout loads only when actually rendered.
const LatencyCreateLayout = lazy(() =>
  import('../../LatencyCreateLayout/LatencyCreateLayout.js').then((m) => ({
    default: m.LatencyCreateLayout,
  })),
);

export const latencyGraderDescriptor: GraderTypeDescriptor = {
  type: 'LatencyGraderSpec',
  supportsEvaluate: false,
  OverviewSections: LatencyOverviewSections,
  create: {
    method: 'latency',
    menuTitle: 'Latency',
    menuDescription: 'Track agent-reported latency as a metric — no LLM.',
    menuIcon: <Timer20Regular />,
    renderLayout: () => <LatencyCreateLayout />,
  },
};
